/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planshare_CreateInputs */

const en_us2_planshare_create = /** @type {(inputs: Planshare_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a code`)
};

const pt_br2_planshare_create = /** @type {(inputs: Planshare_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerar código`)
};

const pt_pt2_planshare_create = /** @type {(inputs: Planshare_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerar código`)
};

/** @type {(inputs: Planshare_CreateInputs) => LocalizedString} */
const es_419_planshare_create = en_us2_planshare_create;

/** @type {(inputs: Planshare_CreateInputs) => LocalizedString} */
const fr_fr2_planshare_create = en_us2_planshare_create;

/** @type {(inputs: Planshare_CreateInputs) => LocalizedString} */
const de_de2_planshare_create = en_us2_planshare_create;

/** @type {(inputs: Planshare_CreateInputs) => LocalizedString} */
const it_it2_planshare_create = en_us2_planshare_create;

/**
* | output |
* | --- |
* | "Create a code" |
*
* @param {Planshare_CreateInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const planshare_create = /** @type {((inputs?: Planshare_CreateInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planshare_CreateInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_planshare_create(inputs)
	if (locale === "es-419") return es_419_planshare_create(inputs)
	if (locale === "pt-PT") return pt_pt2_planshare_create(inputs)
	if (locale === "fr-FR") return fr_fr2_planshare_create(inputs)
	if (locale === "de-DE") return de_de2_planshare_create(inputs)
	if (locale === "it-IT") return it_it2_planshare_create(inputs)
	return en_us2_planshare_create(inputs)
});
export { planshare_create as "planshare.create" }